import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { useModalStore } from 'src/hooks/useStore';
import Modal from 'src/components/ui-kit/Modal';
import { mobilePoint } from 'src/styles/globalStyle';
import { FaDownload } from 'react-icons/fa';

const Wrapper = styled.div`
  display: flex;
  gap: 5px;
  font-family: NotoSansTC-Regular;
  font-size: 16px;
  color: ${colors.white};
  position: absolute;
  margin-top: 10px;
  right: 10%;
  cursor: pointer;
`;
const ModalWrapper = styled.div`
  width: 100%;
  padding: 32px 40px;
  text-align: center;
`;
const ModalContent = styled.div`
  display: flex;
  font-size: 16px;
  line-height: 40px;
  color: ${colors.BlueGray_800};
  gap: 5px;
  text-align: left;

  @media (max-width: ${mobilePoint}) {
    display: grid;
  }
`;
const ModalButtonDiv = styled.div`
  display: grid;
  gap: 1em;
  grid-template-columns: 1fr 1fr;
  justify-items: center;
`;
const ModalButton = styled.button<{ isCancel?: boolean }>`
  width: max-content;
  height: 40px;
  border-radius: 4px;
  background-color: ${(prop) => (prop.isCancel ? colors.notice_orange : colors.primaryGreen_400)};
  color: ${colors.white};
  font-size: 18px;
  margin-top: 2em;
  padding: 0 1em;
  cursor: pointer;
`;

interface IProps {
  csvDownloadPath?: string;
  totalNum: number;
}

/**
 * 下載CSV按鈕
 */
const CsvDownload: React.FC<IProps> = ({ csvDownloadPath, totalNum }) => {
  const closeModal = useModalStore((state) => state.closeModal);
  const setActiveModal = useModalStore((state) => state.setActiveModal);

  const modal = (
    <Modal isAlert={true} width={'20em'}>
      <ModalWrapper>
        <ModalContent>CSV下載功能最多提供前500筆資料。</ModalContent>
        <ModalButtonDiv>
          <ModalButton
            onClick={() => {
              window.open(csvDownloadPath);
              closeModal();
            }}
          >
            確定
          </ModalButton>
          <ModalButton isCancel onClick={() => closeModal()}>
            關閉
          </ModalButton>
        </ModalButtonDiv>
      </ModalWrapper>
    </Modal>
  );

  const handleKeyDown = (
      e: React.KeyboardEvent<Element>, 
      callback: () => void
    ): void => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        callback();
      }
    };
  
  return (
    <Wrapper
      onClick={() => (totalNum > 500 ? setActiveModal(modal) : window.open(csvDownloadPath))}
	  role="button"
	  tabIndex={0}
	  aria-label="下載CSV"
	  onKeyDown={(e) => handleKeyDown(e, () => (totalNum > 500 ? setActiveModal(modal) : window.open(csvDownloadPath)))}
    >
      <FaDownload />
      <span>下載CSV</span>
    </Wrapper>
  );
};

export default CsvDownload;
